import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { OrganizationResidenceTodoProfilEntityState } from '@_model/interfaces/organization-residence-todo-profil.model';

export interface OrganizationResidenceTodoProfilState extends EntityState<OrganizationResidenceTodoProfilEntityState> {
  isLoaded: boolean;
  isLoading: boolean;
  actives: number[];
}

export const adapter: EntityAdapter<OrganizationResidenceTodoProfilEntityState> =
  createEntityAdapter<OrganizationResidenceTodoProfilEntityState>({
    selectId: o => o.idOrganizationResidenceTodoProfil
  });
export const initialState: OrganizationResidenceTodoProfilState = adapter.getInitialState({
  isLoaded: false,
  isLoading: false,
  actives: []
});

export const organizationResidenceTodoProfilFeatureKey = 'organizationResidenceTodoProfil';
